var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"errPage hl-justifyC"},[_vm._v(" 【"+_vm._s(_vm.orgName)+"】尚未开通服务 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }